import { getLiveStream, getReplayStream, getRecordingStream, getVOD, getVODTrailer, getTimeshiftStream, } from '@zattoo/zapi';
import { StreamType, AssetType, HdrType, AudioFormat, } from '@zattoo/playback-sdk';
import { StreamProvider } from '../vod/stream-provider';
export const isRakutenVodRequest = (streamRequestInfo) => {
    const isRakutenVod = streamRequestInfo.assetType === AssetType.VOD &&
        streamRequestInfo.streamProvider === StreamProvider.RAKUTEN;
    return isRakutenVod;
};
export const isRakutenVodTrailerRequest = (streamRequestInfo) => {
    const isRakutenVodTrailer = streamRequestInfo.assetType === AssetType.VOD_TRAILER &&
        streamRequestInfo.streamProvider === StreamProvider.RAKUTEN;
    return isRakutenVodTrailer;
};
export const isRakutenStreamRequest = (streamRequestInfo) => {
    return (isRakutenVodRequest(streamRequestInfo) ||
        isRakutenVodTrailerRequest(streamRequestInfo));
};
export const getZapiStream = (requestInfo) => {
    const streamWatchParams = requestInfo;
    switch (streamWatchParams.assetType) {
        case AssetType.LIVE:
            return getLiveStream(streamWatchParams.watchRequestParams);
        case AssetType.RECORDING:
            return getRecordingStream(streamWatchParams.watchRequestParams);
        case AssetType.REPLAY:
            return getReplayStream(streamWatchParams.watchRequestParams);
        case AssetType.VOD:
            return getVOD(streamWatchParams.watchRequestParams);
        case AssetType.VOD_TRAILER:
            return getVODTrailer(streamWatchParams.watchRequestParams);
        case AssetType.REGISTERED_TIMESHIFT:
            return getTimeshiftStream(streamWatchParams.watchRequestParams);
        default:
            throw new Error('Unsupported media type');
    }
};
export const getCastStreamingProtocol = (options, provider) => {
    if (!options.drmRequired) {
        return StreamType.DASH;
    }
    if (provider === StreamProvider.RAKUTEN) {
        return StreamType.DASH_PLAYREADY;
    }
    return StreamType.DASH_WIDEVINE;
};
export const getStreamingProtocol = (options, capability, provider) => {
    if (!options.drmRequired) {
        const isHls = capability.streamTypeInformation.some((info) => info.type === StreamType.HLS7);
        const isDash = capability.streamTypeInformation.some((info) => info.type === StreamType.DASH);
        if (isHls) {
            return StreamType.HLS7;
        }
        if (isDash) {
            return StreamType.DASH;
        }
        throw new Error('Unsupported streaming protocol');
    }
    if (provider === StreamProvider.RAKUTEN && capability.streamTypeInformation.some((info) => info.type === StreamType.DASH_PLAYREADY)) {
        return StreamType.DASH_PLAYREADY;
    }
    const isHlsFairplay = capability.streamTypeInformation.some((info) => info.type === StreamType.HLS7_FAIRPLAY);
    const isDashWidevine = capability.streamTypeInformation.some((info) => info.type === StreamType.DASH_WIDEVINE);
    const isDashPlayready = capability.streamTypeInformation.some((info) => info.type === StreamType.DASH_PLAYREADY);
    if (isHlsFairplay) {
        return StreamType.HLS7_FAIRPLAY;
    }
    if (isDashWidevine) {
        return StreamType.DASH_WIDEVINE;
    }
    if (isDashPlayready) {
        return StreamType.DASH_PLAYREADY;
    }
    throw new Error('Unsupported streaming protocol');
};
/**
 * Selection of the streaming option is used only for telemetry.
 *
 * This algorithm matches the Python backend implementation in BaseVodVideoWatchCall:
 * 1. Filter by HDR type NONE only
 * 2. If Dolby is preferred, filter for Dolby options
 * 3. Select best match based on audio language
 * 4. Fall back to first option if no language match
 *
 * @see https://github.com/zattoo/bettyy/blob/master/bettyy/model/watch/base_vod_video.py
 */
export const selectTelemetryAudioStreamingOption = (options) => {
    const { streamingOptions, capability, preferredAudioLanguage, preferredAudioFormat, } = options;
    if (!streamingOptions || streamingOptions.length === 0) {
        return null;
    }
    let filteredOptions = streamingOptions.filter((opt) => opt.hdr_types.includes(HdrType.NONE));
    if (filteredOptions.length === 0) {
        return null;
    }
    const isDolbyPreferred = preferredAudioFormat === AudioFormat.DOLBY && capability.dolbySupported;
    if (isDolbyPreferred) {
        const dolbyOptions = filteredOptions.filter((opt) => opt.audio_qualities.includes('5.1'));
        if (dolbyOptions.length > 0) {
            filteredOptions = dolbyOptions;
        }
    }
    if (preferredAudioLanguage) {
        const languageMatch = filteredOptions.find((opt) => opt.audio_language_codes.includes(preferredAudioLanguage));
        if (languageMatch) {
            return languageMatch;
        }
    }
    return filteredOptions[0] ?? null;
};
